import { useMemo } from "react";
import { Controller } from "react-hook-form";
import { useQuery } from "react-query";

import { menuApi } from "src/1/apis/menu.api";
import { CSelectMultiple } from "src/1/common/components/controls";
import { CTextarea } from "src/common/components/controls";

export const Information = ({ control, isBlock }) => {
  //#region Data
  const { data } = useQuery({
    queryKey: ["danh-sach-tat-ca-menu"],
    queryFn: () => menuApi.getAll(),
    select: (response) => response?.data?.data,
  });

  const menus = useMemo(
    () => data?.map((e) => ({ value: e.id, label: e.name }) || []),
    [data],
  );
  //#endregion

  //#region Render
  return (
    <div className="mt-3 flex flex-row gap-3">
      <Controller
        control={control}
        name="adjustment_note"
        render={({ field: { value, onChange } }) => (
          <CTextarea
            value={value}
            onChange={onChange}
            label="Ghi chú"
            placeholder="Lý do điều chỉnh giá"
            rows={4}
            className="flex-1"
            disabled={isBlock}
          />
        )}
      />
      <Controller
        control={control}
        name="menu_ids"
        render={({ field: { value, onChange } }) => (
          <CSelectMultiple
            value={value}
            onChange={onChange}
            className="flex-1"
            label="Menu áp dụng điều chỉnh"
            placeholder="Chọn danh sách menu áp dụng"
            required
            options={menus}
            disabled={isBlock}
          />
        )}
      />
    </div>
  );
  //#endregion
};
